/* Alpha 3D custom print uploader: 3D preview and up to four colors.
   Loads the customer's STL or OBJ into a three.js viewer, prices it from its estimated filament and print time
   (on the older fixed-size product it checks the chosen size instead), and lets them paint it with a brush or a
   smart fill (fills a surface up to its sharp edges). On Add to cart it posts the product form itself with the original file, a preview image and, when colored, a ZIP with a
   colored OBJ + MTL that Bambu Studio and OrcaSlicer can import and map to filaments.
   Markup and styles live in snippets/alpha-print-upload.liquid. */
(function () {
  var FIL = { Gray: '#8c8c8c', Black: '#1c1c1c', White: '#f2f0eb', Orange: '#ff6a1a', Blue: '#2563eb', Red: '#d62828', Yellow: '#f5c518', Green: '#1f9d55', Purple: '#7c3aed', Pink: '#ec4899' };
  var MAX_BYTES = 20 * 1024 * 1024;
  var FILL_ANGLE = Math.cos(30 * Math.PI / 180); // smart fill stops at edges sharper than 30 degrees

  // Instant pricing. Change the rates here: price = setup + filament + machine time, never below the minimum.
  var PRICING = {
    setup: 4,          // dollars per print
    perHour: 1.75,     // dollars per estimated print hour
    minimum: 9,        // dollars per print
    perExtraColor: 2,  // dollars per print for each filament color beyond the first (swaps and purge waste)
    maxSize: 250,      // mm on the longest side; bigger parts go to Get a Quote
    wall: 1.2,         // mm of solid shell assumed around the model
    infill: 0.15,      // share of the inside that is filled
    materials: {
      PLA: { perGram: 0.09, density: 1.24, gramsPerHour: 15 },
      PETG: { perGram: 0.11, density: 1.27, gramsPerHour: 13 },
      TPU: { perGram: 0.16, density: 1.21, gramsPerHour: 6 }
    }
  };

  function hexToRgb(hex) {
    return [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)];
  }

  function init() {
    var box = document.getElementById('a3-print');
    var form = document.querySelector('form[data-type=add-to-cart-form]');
    if (!box || !form) return;

    // form.id would return the form's <input name=id>, so read the attribute.
    var formId = form.getAttribute('id');
    box.querySelectorAll('input, select, textarea').forEach(function (el) { el.setAttribute('form', formId); });

    var $ = function (sel) { return box.querySelector(sel); };
    var T = window.THREE;
    var input = $('#pp-file');
    var drop = $('.pp-drop');
    var dropUi = $('.pp-drop__ui');
    var fileRow = $('.pp-drop__file');
    var viewer = $('#pp-viewer');
    var view = $('#pp-view');
    var info = $('#pp-info');
    var hint = $('#pp-hint');
    var err = $('.pp-err');
    var addButton = form.querySelector('[type=submit][name=add]');
    var quoteBox = $('#pp-quote');
    var materialInput = $('#pp-material-value');
    // Price steps (one variant per price) are only present on the instant-price product.
    var stepsEl = document.getElementById('pp-steps');
    var steps = stepsEl ? JSON.parse(stepsEl.textContent).sort(function (a, b) { return a.price - b.price; }) : null;

    var state = { count: 1, colors: ['Gray', 'Black', 'Orange', 'Blue'], active: 0, tool: 'rotate', brush: 4, size: null, material: 'PLA', quote: null };
    var model = null; // { mesh, geo, faceColor, centroids, normals, vertTris, edgeTris, triVerts, size }
    var busy = false;
    var three = null;

    function showError(msg) {
      err.textContent = msg;
      err.hidden = false;
      err.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    function optionValue(name) {
      var checked = document.querySelector('input[type=radio][name=' + name + ']:checked');
      return checked ? checked.value : '';
    }

    // Size option values look like Small (up to 50 mm); read the limit in millimetres.
    function sizeLimit() {
      var v = optionValue('Size'), at = v.indexOf('up to ');
      return at === -1 ? 0 : parseInt(v.slice(at + 6), 10) || 0;
    }

    function ext(name) { return name.toLowerCase().split('.').pop(); }

    function setupThree() {
      if (!T || !T.OrbitControls) return null;
      var renderer;
      try {
        renderer = new T.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
      } catch (e) {
        return null;
      }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.outputEncoding = T.sRGBEncoding;
      view.appendChild(renderer.domElement);
      var scene = new T.Scene();
      var camera = new T.PerspectiveCamera(35, 1, 0.1, 10000);
      scene.add(new T.HemisphereLight(0xffffff, 0x8a857c, 0.9));
      var sun = new T.DirectionalLight(0xffffff, 0.7);
      sun.position.set(1, 1.4, 1.2);
      scene.add(sun);
      var fill = new T.DirectionalLight(0xffffff, 0.35);
      fill.position.set(-1.2, 0.4, -1);
      scene.add(fill);
      var controls = new T.OrbitControls(camera, renderer.domElement);
      controls.enableDamping = true;
      controls.autoRotate = true;
      controls.autoRotateSpeed = 1.2;
      controls.addEventListener('start', function () { controls.autoRotate = false; });
      var grid = null;

      function resize() {
        var r = view.getBoundingClientRect();
        if (!r.width || !r.height) return;
        renderer.setSize(r.width, r.height, false);
        camera.aspect = r.width / r.height;
        camera.updateProjectionMatrix();
      }

      function frame(size) {
        var d = Math.max(size.x, size.y, size.z) || 10;
        camera.near = d / 100;
        camera.far = d * 100;
        camera.position.set(d * 1.4, d * 1.1, d * 1.6);
        camera.updateProjectionMatrix();
        controls.target.set(0, size.y / 2, 0);
        controls.update();
        if (grid) { scene.remove(grid); grid.geometry.dispose(); }
        grid = new T.GridHelper(Math.ceil(d * 2.4 / 10) * 10, 12, 0xff6a1a, 0xd6d3cc);
        scene.add(grid);
      }

      var visible = true;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(view);
      }
      function loop() {
        requestAnimationFrame(loop);
        if (!visible) return;
        controls.update();
        renderer.render(scene, camera);
      }
      if ('ResizeObserver' in window) new ResizeObserver(resize).observe(view);
      window.addEventListener('resize', resize);
      resize();
      requestAnimationFrame(loop);
      return { renderer: renderer, scene: scene, camera: camera, controls: controls, frame: frame };
    }

    // Shared vertices and edges let the brush spread across the surface and the fill stop at sharp edges.
    function buildTopology(geo) {
      var pos = geo.attributes.position.array, triCount = pos.length / 9;
      var ids = new Map(), triVerts = new Uint32Array(triCount * 3), next = 0;
      for (var v = 0; v < triCount * 3; v++) {
        var key = Math.round(pos[v * 3] * 1e4) + '_' + Math.round(pos[v * 3 + 1] * 1e4) + '_' + Math.round(pos[v * 3 + 2] * 1e4);
        var id = ids.get(key);
        if (id === undefined) { id = next++; ids.set(key, id); }
        triVerts[v] = id;
      }
      var vertTris = new Array(next);
      for (var i = 0; i < next; i++) vertTris[i] = [];
      var edgeTris = new Map();
      var centroids = new Float32Array(triCount * 3), normals = new Float32Array(triCount * 3);
      for (var t = 0; t < triCount; t++) {
        var a = triVerts[t * 3], b = triVerts[t * 3 + 1], c = triVerts[t * 3 + 2];
        vertTris[a].push(t); vertTris[b].push(t); vertTris[c].push(t);
        [[a, b], [b, c], [c, a]].forEach(function (e) {
          var k = e[0] < e[1] ? e[0] + '_' + e[1] : e[1] + '_' + e[0];
          var list = edgeTris.get(k);
          if (list) list.push(t); else edgeTris.set(k, [t]);
        });
        var o = t * 9;
        var ax = pos[o], ay = pos[o + 1], az = pos[o + 2];
        var ux = pos[o + 3] - ax, uy = pos[o + 4] - ay, uz = pos[o + 5] - az;
        var wx = pos[o + 6] - ax, wy = pos[o + 7] - ay, wz = pos[o + 8] - az;
        var nx = uy * wz - uz * wy, ny = uz * wx - ux * wz, nz = ux * wy - uy * wx, nl = Math.hypot(nx, ny, nz) || 1;
        normals[t * 3] = nx / nl; normals[t * 3 + 1] = ny / nl; normals[t * 3 + 2] = nz / nl;
        centroids[t * 3] = (pos[o] + pos[o + 3] + pos[o + 6]) / 3;
        centroids[t * 3 + 1] = (pos[o + 1] + pos[o + 4] + pos[o + 7]) / 3;
        centroids[t * 3 + 2] = (pos[o + 2] + pos[o + 5] + pos[o + 8]) / 3;
      }
      return { triVerts: triVerts, vertTris: vertTris, edgeTris: edgeTris, centroids: centroids, normals: normals, triCount: triCount };
    }

    function edgeNeighbors(t) {
      var tv = model.triVerts, out = [];
      for (var e = 0; e < 3; e++) {
        var a = tv[t * 3 + e], b = tv[t * 3 + (e + 1) % 3];
        var list = model.edgeTris.get(a < b ? a + '_' + b : b + '_' + a) || [];
        for (var i = 0; i < list.length; i++) if (list[i] !== t) out.push(list[i]);
      }
      return out;
    }

    function colorize(tris) {
      var col = model.geo.attributes.color, rgbs = state.colors.map(function (n) {
        var c = hexToRgb(FIL[n]);
        return new T.Color(c[0] / 255, c[1] / 255, c[2] / 255).convertSRGBToLinear();
      });
      var list = tris || Array.from({ length: model.triCount }, function (_, i) { return i; });
      for (var i = 0; i < list.length; i++) {
        var t = list[i], c = rgbs[Math.min(model.faceColor[t], state.count - 1)];
        for (var k = 0; k < 3; k++) col.setXYZ(t * 3 + k, c.r, c.g, c.b);
      }
      col.needsUpdate = true;
    }

    // Brush: paint every triangle within the brush radius of the hit point, spreading over shared vertices.
    function brushAt(t0, point) {
      var r2 = state.brush * state.brush, seen = new Set([t0]), queue = [t0], changed = [];
      while (queue.length) {
        var t = queue.pop(), c = model.centroids;
        var dx = c[t * 3] - point.x, dy = c[t * 3 + 1] - point.y, dz = c[t * 3 + 2] - point.z;
        if (t !== t0 && dx * dx + dy * dy + dz * dz > r2) continue;
        if (model.faceColor[t] !== state.active) { model.faceColor[t] = state.active; changed.push(t); }
        for (var k = 0; k < 3; k++) {
          var around = model.vertTris[model.triVerts[t * 3 + k]];
          for (var i = 0; i < around.length; i++) if (!seen.has(around[i])) { seen.add(around[i]); queue.push(around[i]); }
        }
      }
      if (changed.length) colorize(changed);
    }

    // Smart fill: flood across neighbouring triangles until the surface turns sharper than FILL_ANGLE.
    function fillFrom(t0) {
      var n = model.normals, seen = new Set([t0]), queue = [t0], changed = [];
      while (queue.length) {
        var t = queue.pop();
        model.faceColor[t] = state.active;
        changed.push(t);
        var nb = edgeNeighbors(t);
        for (var i = 0; i < nb.length; i++) {
          var u = nb[i];
          if (seen.has(u)) continue;
          var dot = n[t * 3] * n[u * 3] + n[t * 3 + 1] * n[u * 3 + 1] + n[t * 3 + 2] * n[u * 3 + 2];
          if (dot >= FILL_ANGLE) { seen.add(u); queue.push(u); }
        }
      }
      colorize(changed);
    }

    // Solid volume (mm3) and surface area (mm2) of the mesh; volume uses signed tetrahedra so it suits closed models.
    function measure(geo) {
      var p = geo.attributes.position.array, vol = 0, area = 0;
      for (var o = 0; o < p.length; o += 9) {
        var ax = p[o], ay = p[o + 1], az = p[o + 2], bx = p[o + 3], by = p[o + 4], bz = p[o + 5], cx = p[o + 6], cy = p[o + 7], cz = p[o + 8];
        vol += (ax * (by * cz - bz * cy) - ay * (bx * cz - bz * cx) + az * (bx * cy - by * cx)) / 6;
        var ux = bx - ax, uy = by - ay, uz = bz - az, wx = cx - ax, wy = cy - ay, wz = cz - az;
        area += Math.hypot(uy * wz - uz * wy, uz * wx - ux * wz, ux * wy - uy * wx) / 2;
      }
      return { volume: Math.abs(vol), area: area };
    }

    function money(n) { return '$' + n.toFixed(2); }

    function hoursText(h) {
      var m = Math.max(5, Math.round(h * 60 / 5) * 5);
      return m < 60 ? m + ' min' : Math.floor(m / 60) + ' h' + (m % 60 ? ' ' + (m % 60) + ' min' : '');
    }

    // Estimate filament, print time and price for one copy, then pick the first price step at or above it.
    function updateQuote() {
      if (!steps) return;
      state.quote = null;
      quoteBox.hidden = true;
      if (!model) { setPrice(null); return; }
      var mat = PRICING.materials[state.material] || PRICING.materials.PLA;
      var s = model.size, longest = Math.max(s.x, s.y, s.z);
      var shell = Math.min(model.volume, model.area * PRICING.wall);
      var grams = mat.density * (shell + Math.max(0, model.volume - shell) * PRICING.infill) / 1000;
      var hours = grams / mat.gramsPerHour + 0.15;
      var colorFee = (state.count - 1) * PRICING.perExtraColor;
      var raw = Math.max(PRICING.minimum, PRICING.setup + grams * mat.perGram + hours * PRICING.perHour) + colorFee;
      var step = null;
      for (var i = 0; i < steps.length; i++) if (steps[i].price >= raw - 0.005) { step = steps[i]; break; }
      quoteBox.hidden = false;
      quoteBox.classList.remove('is-warn');
      if (longest > PRICING.maxSize || !step) {
        quoteBox.classList.add('is-warn');
        quoteBox.innerHTML = '<strong>Too big for an instant price.</strong> ' + (longest > PRICING.maxSize ? 'This model is over ' + PRICING.maxSize + ' mm on its longest side.' : 'This print comes to more than ' + money(steps[steps.length - 1].price) + '.') + ' <a href="/pages/get-a-quote">Request a quote</a> and we will price it by hand.';
        setPrice(null);
        return;
      }
      state.quote = { variant: step.id, price: step.price, grams: grams, hours: hours };
      quoteBox.innerHTML = '<span class="pp-quote__price">' + money(step.price) + '</span><span class="pp-quote__each">per print in ' + state.material + '</span>' +
        '<span class="pp-quote__meta">About ' + Math.max(1, Math.round(grams)) + ' g of filament and ' + hoursText(hours) + ' of printing' +
        (colorFee ? ', including ' + money(colorFee) + ' for ' + state.count + ' colors' : '') + '</span>';
      setPrice(step.price);
    }

    // Show the instant price in the theme's price line under the title.
    var priceEls = document.querySelectorAll('.product__info-container .price .price-item');
    var priceDefault = Array.prototype.map.call(priceEls, function (el) { return el.textContent; });
    function setPrice(p) {
      Array.prototype.forEach.call(priceEls, function (el, i) {
        el.textContent = p === null ? priceDefault[i] : money(p) + ' USD';
      });
    }

    function showInfo() {
      if (!model) { info.textContent = ''; return; }
      var s = model.size, limit = sizeLimit(), longest = Math.max(s.x, s.y, s.z);
      var dims = s.x.toFixed(1) + ' x ' + s.z.toFixed(1) + ' x ' + s.y.toFixed(1) + ' mm';
      if (steps) {
        info.className = 'pp-info';
        info.textContent = 'Model size: ' + dims + '.' + (longest < 5 ? ' That is very small; check the file was exported in millimetres.' : '');
        updateQuote();
        return;
      }
      if (limit && longest > limit) {
        info.className = 'pp-info is-warn';
        info.textContent = 'Model size: ' + dims + '. That is bigger than ' + limit + ' mm, so pick a larger size or request a quote.';
      } else {
        info.className = 'pp-info';
        info.textContent = 'Model size: ' + dims + (limit ? '. Fits the selected size (up to ' + limit + ' mm).' : '.');
      }
    }

    function loadGeometry(file) {
      var kind = ext(file.name);
      var reader = new FileReader();
      reader.onload = function () {
        var geo = null;
        try {
          if (kind === 'stl' && T.STLLoader) {
            geo = new T.STLLoader().parse(reader.result);
          } else if (kind === 'obj' && T.OBJLoader) {
            var text = new TextDecoder().decode(new Uint8Array(reader.result));
            var obj = new T.OBJLoader().parse(text), parts = [];
            obj.traverse(function (o) { if (o.isMesh) parts.push(o.geometry.index ? o.geometry.toNonIndexed() : o.geometry); });
            geo = mergePositions(parts);
          }
        } catch (e) {
          geo = null;
        }
        if (!geo || !geo.attributes.position || !geo.attributes.position.count) {
          viewer.hidden = true;
          showError(steps
            ? 'We could not read this file to price it. Please check it is a valid STL or OBJ, or send it through Get a Quote.'
            : 'We could not read this file for a preview. You can still order with it, and we will check it before printing.');
          return;
        }
        showModel(geo);
      };
      reader.readAsArrayBuffer(file);
    }

    function mergePositions(parts) {
      var total = 0;
      parts.forEach(function (g) { total += g.attributes.position.array.length; });
      var out = new Float32Array(total), o = 0;
      parts.forEach(function (g) { out.set(g.attributes.position.array, o); o += g.attributes.position.array.length; });
      var geo = new T.BufferGeometry();
      geo.setAttribute('position', new T.BufferAttribute(out, 3));
      return geo;
    }

    function showModel(geo) {
      if (geo.index) geo = geo.toNonIndexed();
      // Models are printed Z-up; turn them Y-up for the viewer, sit them on the plate and centre them.
      geo.rotateX(-Math.PI / 2);
      geo.computeBoundingBox();
      var bb = geo.boundingBox;
      geo.translate(-(bb.min.x + bb.max.x) / 2, -bb.min.y, -(bb.min.z + bb.max.z) / 2);
      geo.computeBoundingBox();
      geo.computeVertexNormals();
      var size = new T.Vector3();
      geo.boundingBox.getSize(size);
      geo.setAttribute('color', new T.BufferAttribute(new Float32Array(geo.attributes.position.count * 3), 3));
      if (model) { three.scene.remove(model.mesh); model.geo.dispose(); }
      var topo = buildTopology(geo);
      var mesh = new T.Mesh(geo, new T.MeshStandardMaterial({ vertexColors: true, roughness: 0.6, metalness: 0 }));
      var m = measure(geo);
      model = Object.assign(topo, { mesh: mesh, geo: geo, size: size, volume: m.volume, area: m.area, faceColor: new Uint8Array(topo.triCount) });
      three.scene.add(mesh);
      three.frame(size);
      three.controls.autoRotate = true;
      colorize();
      viewer.hidden = false;
      showInfo();
      setTool('rotate');
    }

    function loadFile() {
      err.hidden = true;
      var file = input.files[0];
      if (model) { three.scene.remove(model.mesh); model.geo.dispose(); model = null; }
      updateQuote();
      if (!file) {
        fileRow.hidden = true; dropUi.hidden = false; drop.classList.remove('is-filled');
        viewer.hidden = true;
        info.textContent = '';
        return;
      }
      if (file.size > MAX_BYTES) {
        input.value = '';
        loadFile();
        showError('That file is over 20 MB. Please send larger files through Get a Quote.');
        return;
      }
      fileRow.querySelector('.pp-drop__name').textContent = file.name;
      fileRow.hidden = false; dropUi.hidden = true; drop.classList.add('is-filled');
      var kind = ext(file.name);
      if (!three || (kind !== 'stl' && kind !== 'obj')) {
        viewer.hidden = true;
        info.className = 'pp-info';
        info.textContent = steps
          ? 'Instant pricing works with STL and OBJ files. Export your model as STL, or send your ' + kind.toUpperCase() + ' file through Get a Quote.'
          : three ? 'Preview and coloring work with STL and OBJ files. We will still print from your ' + kind.toUpperCase() + ' file.' : '';
        if (steps) info.className = 'pp-info is-warn';
        info.hidden = !three;
        return;
      }
      loadGeometry(file);
    }

    function swatch(name, selected, onPick, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pp-sw' + (selected ? ' is-on' : '');
      b.style.setProperty('--c', FIL[name]);
      b.title = label || name;
      b.setAttribute('aria-label', label || name);
      b.setAttribute('aria-pressed', selected ? 'true' : 'false');
      b.addEventListener('click', onPick);
      return b;
    }

    function renderColorUI() {
      if (state.active >= state.count) state.active = 0;
      var rows = $('#pp-palettes');
      rows.innerHTML = '';
      for (var i = 0; i < state.count; i++) {
        (function (slot) {
          var row = document.createElement('div');
          row.className = 'pp-prow';
          var lab = document.createElement('span');
          lab.className = 'pp-plabel';
          lab.textContent = slot === 0 ? 'Main color' : 'Color ' + (slot + 1);
          var list = document.createElement('div');
          list.className = 'pp-swatches';
          Object.keys(FIL).forEach(function (name) {
            list.appendChild(swatch(name, state.colors[slot] === name, function () { state.colors[slot] = name; renderColorUI(); if (model) colorize(); }));
          });
          row.appendChild(lab);
          row.appendChild(list);
          rows.appendChild(row);
        })(i);
      }
      var act = $('#pp-active');
      act.innerHTML = '';
      for (var j = 0; j < state.count; j++) {
        (function (slot) {
          act.appendChild(swatch(state.colors[slot], state.active === slot, function () { state.active = slot; renderColorUI(); }, 'Paint with ' + state.colors[slot]));
        })(j);
      }
      $('#pp-painttools').hidden = state.count < 2;
    }

    function setTool(tool) {
      state.tool = tool;
      box.querySelectorAll('#pp-tool button').forEach(function (b) { b.classList.toggle('is-on', b.dataset.tool === tool); });
      if (three) {
        three.controls.enabled = tool === 'rotate';
        // Hold the model still while painting so clicks land where the customer aims.
        if (tool !== 'rotate') three.controls.autoRotate = false;
      }
      $('#pp-brushsize').hidden = tool !== 'brush';
      hint.textContent = tool === 'rotate' ? 'Drag to rotate, scroll or pinch to zoom' : tool === 'brush' ? 'Drag over the model to paint' : 'Click a surface to fill it';
      view.style.cursor = tool === 'rotate' ? 'grab' : 'crosshair';
    }

    // Pointer painting on the model.
    var raycaster = T ? new T.Raycaster() : null, painting = false;
    function hit(e) {
      var r = three.renderer.domElement.getBoundingClientRect();
      var p = new T.Vector2(((e.clientX - r.left) / r.width) * 2 - 1, -((e.clientY - r.top) / r.height) * 2 + 1);
      raycaster.setFromCamera(p, three.camera);
      var found = raycaster.intersectObject(model.mesh, false);
      return found.length ? found[0] : null;
    }
    function onPaint(e) {
      if (!model || state.tool === 'rotate' || state.count < 2) return;
      var h = hit(e);
      if (!h) return;
      if (state.tool === 'fill') fillFrom(h.faceIndex);
      else brushAt(h.faceIndex, h.point);
    }

    function previewBlob() {
      if (!three || !model) return Promise.resolve(null);
      three.renderer.render(three.scene, three.camera);
      return new Promise(function (resolve) { three.renderer.domElement.toBlob(resolve, 'image/png'); });
    }

    // Colored OBJ + MTL (one material per filament color), in millimetres and Z-up for slicing.
    function paintedZip() {
      if (!model || state.count < 2 || !window.JSZip) return Promise.resolve(null);
      var pos = model.geo.attributes.position.array, ids = new Map(), verts = [], faces = [];
      for (var s = 0; s < state.count; s++) faces.push([]);
      for (var v = 0; v < pos.length / 3; v++) {
        // Undo the viewer's Y-up turn: (x, y, z) viewer = (x, z, -y) print.
        var x = pos[v * 3], y = -pos[v * 3 + 2], z = pos[v * 3 + 1];
        var key = x.toFixed(4) + ' ' + y.toFixed(4) + ' ' + z.toFixed(4);
        var id = ids.get(key);
        if (id === undefined) { verts.push('v ' + key); id = verts.length; ids.set(key, id); }
        faces[Math.min(model.faceColor[Math.floor(v / 3)], state.count - 1)].push(id);
      }
      var obj = ['# Alpha 3D Printing Co. painted model (millimetres)', 'mtllib model.mtl', 'o model'].concat(verts);
      var mtl = ['# One material per filament color'], readme = [];
      for (var c = 0; c < state.count; c++) {
        if (!faces[c].length) continue;
        var rgb = hexToRgb(FIL[state.colors[c]]);
        mtl.push('newmtl color' + (c + 1) + '_' + state.colors[c].toLowerCase(), 'Kd ' + (rgb[0] / 255).toFixed(4) + ' ' + (rgb[1] / 255).toFixed(4) + ' ' + (rgb[2] / 255).toFixed(4), '');
        obj.push('usemtl color' + (c + 1) + '_' + state.colors[c].toLowerCase());
        for (var f = 0; f < faces[c].length; f += 3) obj.push('f ' + faces[c][f] + ' ' + faces[c][f + 1] + ' ' + faces[c][f + 2]);
        readme.push('  color' + (c + 1) + '_' + state.colors[c].toLowerCase() + '  ->  ' + state.colors[c] + ' filament');
      }
      var zip = new window.JSZip();
      zip.file('model.obj', obj.join('\n') + '\n');
      zip.file('model.mtl', mtl.join('\n') + '\n');
      zip.file('README.txt', [
        'Alpha 3D Printing Co. painted model',
        '',
        'Import model.obj (keep model.mtl next to it) into Bambu Studio or OrcaSlicer;',
        'the colors come in as materials that map to filaments:',
        readme.join('\n'),
        '',
        'The original upload is attached to the order separately.'
      ].join('\n') + '\n');
      return zip.generateAsync({ type: 'blob', compression: 'DEFLATE' });
    }

    function setBusy(on) {
      busy = on;
      if (!addButton) return;
      addButton.classList.toggle('loading', on);
      if (on) { addButton.setAttribute('aria-disabled', 'true'); } else { addButton.removeAttribute('aria-disabled'); }
    }

    function post(fd) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: fd })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok && !data.status, data: data }; }); });
    }

    function formData(png, zipBlob) {
      var fd = new FormData(form);
      if (!$('#pp-notes').value.trim()) fd.delete('properties[Notes]');
      var used = state.colors.slice(0, state.count);
      fd.append('properties[Colors]', state.count > 1 ? used.join(', ') : used[0] + ' (single color)');
      if (model) fd.append('properties[Model size]', model.size.x.toFixed(1) + ' x ' + model.size.z.toFixed(1) + ' x ' + model.size.y.toFixed(1) + ' mm');
      if (state.quote) {
        fd.set('id', state.quote.variant);
        fd.append('properties[Estimate]', Math.max(1, Math.round(state.quote.grams)) + ' g, ' + hoursText(state.quote.hours) + ' per print');
      }
      if (png) fd.append('properties[Preview]', new File([png], 'model-preview.png', { type: 'image/png' }));
      if (zipBlob) fd.append('properties[Painted model]', new File([zipBlob], 'painted-model.zip', { type: 'application/zip' }));
      return fd;
    }

    function addToCart(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy) return;
      err.hidden = true;
      if (!input.files.length) {
        showError('Please upload your 3D file before adding to cart.');
        return;
      }
      if (steps && !state.quote) {
        showError(model ? 'This model is too big for an instant price. Please request a quote instead.' : 'We need an STL or OBJ file to price your print. Please upload one, or request a quote.');
        return;
      }
      setBusy(true);
      var png = null;
      previewBlob()
        .then(function (blob) { png = blob; return paintedZip().catch(function () { return null; }); })
        .then(function (zipBlob) { return post(formData(png, zipBlob)).then(function (r) { return r.ok || !zipBlob ? r : post(formData(png, null)); }); })
        .then(function (r) {
          if (!r.ok) {
            setBusy(false);
            showError(r.data.description || 'Something went wrong adding this to your cart. Please try again.');
            return;
          }
          window.location.href = '/cart';
        })
        .catch(function () {
          setBusy(false);
          showError('Your file could not be uploaded. Check your connection and try again.');
        });
    }

    three = setupThree();
    input.addEventListener('change', loadFile);
    ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function () { drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function () { drop.classList.remove('is-over'); }); });
    $('.pp-drop__clear').addEventListener('click', function () { input.value = ''; loadFile(); input.click(); });
    $('#pp-count').addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      box.querySelectorAll('#pp-count button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      state.count = Number(b.dataset.count);
      renderColorUI();
      if (model) colorize();
      if (state.count < 2) setTool('rotate');
      updateQuote();
    });
    $('#pp-tool').addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (b) setTool(b.dataset.tool);
    });
    $('#pp-brush').addEventListener('input', function (e) { state.brush = Number(e.target.value); });
    $('#pp-reset').addEventListener('click', function () { if (model) { model.faceColor.fill(0); colorize(); } });
    document.addEventListener('change', function (e) { if (e.target.name === 'Size') showInfo(); });
    if (steps) {
      $('#pp-material').addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        box.querySelectorAll('#pp-material button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        state.material = b.dataset.material;
        materialInput.value = state.material;
        updateQuote();
      });
    }
    if (three) {
      var canvas = three.renderer.domElement;
      canvas.addEventListener('pointerdown', function (e) {
        if (state.tool === 'rotate') return;
        painting = state.tool === 'brush';
        try { canvas.setPointerCapture(e.pointerId); } catch (x) { /* capture is only a nicety */ }
        onPaint(e);
      });
      canvas.addEventListener('pointermove', function (e) { if (painting) onPaint(e); });
      ['pointerup', 'pointercancel'].forEach(function (t) { canvas.addEventListener(t, function () { painting = false; }); });
    }

    // Capture phase on document runs before the theme's and any app's handlers on the button or form.
    document.addEventListener('click', function (e) {
      if (addButton && e.target.closest && e.target.closest('[type=submit][name=add]') === addButton) addToCart(e);
    }, true);
    document.addEventListener('submit', function (e) {
      if (e.target === form) addToCart(e);
    }, true);

    renderColorUI();
    setTool('rotate');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
